module.exports = __webpack_public_path__ + "static/media/dealsareus.b4700c0c.png";